import * as tslib_1 from "tslib";
// 3rd party imports
import { Type } from 'class-transformer';
// Common imports
import { Utils } from 'cc-common';
// Model imports
import { KeyValueResultDto } from '../../_models/key-value-result-dto';
import { BlockIssuesResultDto } from './block-issues-result-dto';
import { ConveyanceCommunityARBankResultDto } from './conveyance-community-ar-bank-result-dto';
import { ConveyanceCommunityResultDto } from './conveyance-community-result-dto';
import { ConveyanceCommunitySoaRequestsRawDto } from './conveyance-community-soa-requests-raw-dto';
import { ConveyancePropertyInfoResultDto } from './conveyance-property-info-result-dto';
const ɵ0 = () => BlockIssuesResultDto, ɵ1 = () => ConveyanceCommunityResultDto, ɵ2 = () => ConveyancePropertyInfoResultDto, ɵ3 = () => KeyValueResultDto, ɵ4 = () => ConveyanceCommunityARBankResultDto, ɵ5 = () => Date, ɵ6 = () => Date, ɵ7 = () => Date, ɵ8 = () => Date, ɵ9 = () => Date, ɵ10 = () => Date, ɵ11 = () => ConveyanceCommunitySoaRequestsRawDto;
export class ConveyanceEditorResultDto {
    // Transient
    get conveyanceHasOpenViolations() {
        return Utils.notNullAndDefined(this.openViolationCount) && this.openViolationCount > 0;
    }
}
tslib_1.__decorate([
    Type(ɵ0),
    tslib_1.__metadata("design:type", Array)
], ConveyanceEditorResultDto.prototype, "blockIssues", void 0);
tslib_1.__decorate([
    Type(ɵ1),
    tslib_1.__metadata("design:type", Array)
], ConveyanceEditorResultDto.prototype, "conveyanceCommunities", void 0);
tslib_1.__decorate([
    Type(ɵ2),
    tslib_1.__metadata("design:type", ConveyancePropertyInfoResultDto)
], ConveyanceEditorResultDto.prototype, "property", void 0);
tslib_1.__decorate([
    Type(ɵ3),
    tslib_1.__metadata("design:type", Array)
], ConveyanceEditorResultDto.prototype, "conveyanceTypes", void 0);
tslib_1.__decorate([
    Type(ɵ4),
    tslib_1.__metadata("design:type", Array)
], ConveyanceEditorResultDto.prototype, "communityARDefaultBankNames", void 0);
tslib_1.__decorate([
    Type(ɵ5),
    tslib_1.__metadata("design:type", Date)
], ConveyanceEditorResultDto.prototype, "minClosingDate", void 0);
tslib_1.__decorate([
    Type(ɵ6),
    tslib_1.__metadata("design:type", Date)
], ConveyanceEditorResultDto.prototype, "maxClosingDate", void 0);
tslib_1.__decorate([
    Type(ɵ7),
    tslib_1.__metadata("design:type", Date)
], ConveyanceEditorResultDto.prototype, "defaultGLPostDate", void 0);
tslib_1.__decorate([
    Type(ɵ8),
    tslib_1.__metadata("design:type", Date)
], ConveyanceEditorResultDto.prototype, "minGLPostDate", void 0);
tslib_1.__decorate([
    Type(ɵ9),
    tslib_1.__metadata("design:type", Date)
], ConveyanceEditorResultDto.prototype, "maxGLPostDate", void 0);
tslib_1.__decorate([
    Type(ɵ10),
    tslib_1.__metadata("design:type", Date)
], ConveyanceEditorResultDto.prototype, "maxPaperworkReceivedDate", void 0);
tslib_1.__decorate([
    Type(ɵ11),
    tslib_1.__metadata("design:type", ConveyanceCommunitySoaRequestsRawDto)
], ConveyanceEditorResultDto.prototype, "conveyanceSOARequests", void 0);
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5, ɵ6, ɵ7, ɵ8, ɵ9, ɵ10, ɵ11 };
